export default __webpack_public_path__ + "static/arise_and_shine-48e306803c69713d43e36c1c7b7ff907.png";